// import * as THREE from 'three';
// import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { gsap } from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Lenis from '@studio-freight/lenis';
import barba from '@barba/core';
import Vivus from 'vivus';
import $ from 'jquery';
import { initCategoryTabs } from './categoryTabUtils.js';
// import { initModal } from './modalUtils.js';
// import { initAccordion } from "./accordionUtils.;js";
import { preventEnterSubmit } from "./formUtils.js"
// import { initHeaderScrollBehavior } from "./initHeaderScrollBehavior.js";
import { initSwiper } from "./initSwiper.js"
import { deviceBrowserCheck } from "./deviceBrowserCheck.js";
import { vivusAnimationDuration } from "./vivusDurationcalc.js";
import { pageLeaveAnimationPixel, startNoisePhase, startDissolvePhase } from './pageLeaveAnimationPixel.js';
pageLeaveAnimationPixel(); // 初回だけ呼ぶ（初期化）

gsap.registerPlugin(ScrollTrigger);
gsap.config({
  nullTargetWarn: false,   // 存在しないターゲットに対する警告を非表示にする
  trialWarn: false         // GSAPのプラグインライセンス関連の警告を非表示にする
});
// import { OrbitControls } from 'OrbitControls';
// import { GUI } from 'dat.gui';
// lenis



if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

function reloadPageOnResize() {
  const initialWidth = window.innerWidth;
  let resizeTimeout;

  window.addEventListener('resize', () => {
    const currentWidth = window.innerWidth;

    clearTimeout(resizeTimeout); // 前回のタイマーをクリア
    resizeTimeout = setTimeout(() => {
      if (currentWidth !== initialWidth) {
        // ページをリロード
        location.reload();
      }
    }, 300); // 300ms 待機
  });
}
reloadPageOnResize();


window.addEventListener('load', () => {
  scrollTopInit();
});



deviceBrowserCheck();
// vivusDurationcalc()



function easeOutCirc(x) {
  // return Math.sqrt(1 - Math.pow(x - 1, 2));
  return 1 - Math.pow(1 - x, 4);
}
const lenis = new Lenis({
  duration: 1.8,     // スクロールにかかる時間（大きいほど重くなる）
  // lerp: 0.2, // 慣性の強さ
  easing: easeOutCirc, // カスタムイージング関数
  // easing: (t) => 1 - Math.pow(1 - t, 4) // easeOutQuart
  // easing: (t) => t * (2 - t), // easeOutQuad（自然でバランスがいい）
});
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);






// =====================================
// ヘッダー＆メニュー周りのスクリプト
// =====================================
  function headerMenuScript() {
  const header = document.querySelector(".c_header");
  const headerTriggerBtns = document.querySelectorAll(".js_menuTrg");
  const headerMenuWrapper = document.querySelector(".c_mainMenu");
  const links = document.querySelectorAll(".c_header_menu a,.c_mainMenu a");
  const darkTargets = document.querySelectorAll(".c_header, .c_sideBar");

  if (!header || !headerMenuWrapper || headerTriggerBtns.length === 0) {
    return; // 必須要素がなければ何もしない
  }

  function openMenu() {
    lenis?.stop();
    headerTriggerBtns.forEach(btn => btn.classList.add("is_open"));
    headerMenuWrapper.classList.add("is_open");
    header.classList.add("is_open");
    darkTargets.forEach(el => el.classList.add("is_dark"));
  }

  function closeMenu() {
    lenis?.start();
    headerTriggerBtns.forEach(btn => btn.classList.remove("is_open"));
    headerMenuWrapper.classList.remove("is_open");
    header.classList.remove("is_open");
    darkTargets.forEach(el => el.classList.remove("is_dark"));
  }

  function toggleMenu() {
    const isOpen = headerMenuWrapper.classList.contains("is_open");
    if (isOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  // トリガーボタン
  headerTriggerBtns.forEach(btn => {
    btn.addEventListener("click", toggleMenu);
  });

  // メニュー内リンククリックで閉じる
  links.forEach(link => {
    link.addEventListener("click", closeMenu);
  });
}

headerMenuScript();

// Vivus.jsのスクリプト

function letteringHoverInit() {
  const hoverTargets = document.querySelectorAll('.js_lHover');

  hoverTargets.forEach(target => {
    target.addEventListener('mouseenter', () => {
      target.classList.add('is_active');

      const letteringEl = target.querySelector('.c_header_lettering');
      if (letteringEl) {
        // ホバーのたびに描画アニメをリスタートしたい場合は new Vivus を毎回作成
        new Vivus(letteringEl, {
          type: 'delayed',
          duration: vivusAnimationDuration(80),
          start: 'autostart',
          forceRender: true, // ← 再描画を強制
        });
      }
    });

    target.addEventListener('mouseleave', () => {
      target.classList.remove('is_active');
    });
  });
}

letteringHoverInit();



// すべてのlenisのアンカーリンクを取得
// const anchors = document.querySelectorAll("[data-scroll-target]");
// console.log(anchors)
// // すべてのアンカーに対してイベントリスナーを設定
// anchors.forEach(anchor => {
//   anchor.addEventListener("click", (e) => {
//     // URLを変更しないようにする
//     console.log("アンカークリック");
//     e.preventDefault();
//     lenis.start();
//     // data-scroll-target属性を取得
//     const target = anchor.getAttribute("data-scroll-target");

//     // スクロール
//     if (target) {
//       setTimeout(() => {
//         lenis.scrollTo("#" + target, {
//           duration: 1.5,  // スクロールにかける時間（ミリ秒）
//           // easing: 'easeInOutCubic'  // イージング関数
//         });
//         // lenis.scrollTo(0);
//       }, 0);
//     }
//   });
// });


////////////////////////////////////////////////////////////////////
// balba.js
////////////////////////////////////////////////////////////////////


function scrollTopInit(link) {

  // lenis.stop(); // 必要に応じてコメント解除


  // リンクをクリックした場合はtrue、それ以外（ブラウザバックなど）
  if (link && link instanceof Element) {
    console.log("リンクをクリック")
    const href = link.getAttribute('href'); // href属性を取得
    const target = link.getAttribute('data-scroll-target'); // data-scroll-targetを取得
    // console.log(`クリックされたリンクのhref: ${href}, ターゲット: ${target}`);

    // href と現在のURLが一致しているか確認
    const currentURL = window.location.href.split('#')[0]; // #以降を除外して現在のURLを取得
    const hrefURL = new URL(href, window.location.origin).href.split('#')[0]; // 絶対URLとしてhrefを解析
    console.log(hrefURL)
    console.log(currentURL)
    if (currentURL === hrefURL && target) {
      // hrefが現在のURLと一致し、ターゲットが指定されている場合
      const targetElement = document.querySelector(`#${target}`);
      if (targetElement) {
        setTimeout(() => {
          // lenis.scrollTo(0, {
          //   duration: 0,  // スクロールにかける時間（ミリ秒）
          // });
          console.log("分岐点（Anker Link）");
          // const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset; // スクロール位置を計算
          // console.log(targetPosition)
          // window.scrollTo({
          //   top: targetPosition,
          //   behavior: 'smooth'
          // });
          setTimeout(() => {
            // ScrollTrigger.clearScrollMemory();
            // ScrollTrigger.refresh();
          }, 400);
          setTimeout(() => {
            const targetId = target;
            const isSP = window.innerWidth <= 767;
            const container = isSP ? undefined : document.querySelector('.hs_scroller');

            let targetPos;

            if (targetId === "end") {
              // 最後尾へスクロール
              if (isSP) {
                // SPの場合はinnerHeight
                targetPos = document.body.scrollHeight - window.innerHeight;
              } else if (container) {
                // innerWidth
                targetPos = container.scrollWidth - window.innerWidth;
              } else {
                return; // コンテナがなければ処理しない
              }
            } else {
              const target = document.getElementById(targetId);
              if (!target) return;
              targetPos = isSP ? target.offsetTop : target.offsetLeft;
            }

            lenis.scrollTo(targetPos, {
              duration: 2,
              lerp: 0.2,
              container: container
            });



          }, 500);
        }, 500);
        // return;
      }
    } else {
      // 一致しない、またはターゲットが指定されていない場合のデフォルト処理
      console.log("分岐点1")
      setTimeout(() => {
        lenis.scrollTo(0, {
          duration: 0,  // スクロールにかける時間（ミリ秒）
        });
        if (currentNamespace === 'index') {
          document.querySelector('.c_header').classList.remove('is_dark');
          document.querySelector('.c_sideBar').classList.remove('is_dark');
          document.querySelector('.progressBar').classList.remove('is_dark');
          document.querySelectorAll('.js_bgDark').forEach(el => {
            el.classList.remove('is_active');
          });
        } else {
          document.querySelector('.c_header').classList.remove('is_dark');
          document.querySelector('.c_sideBar').classList.remove('is_dark');
          document.querySelectorAll('.js_bgDark').forEach(el => {
            el.classList.remove('is_active');
          });
        }
        setTimeout(() => {
          // ScrollTrigger.clearScrollMemory();
          // ScrollTrigger.refresh();
        }, 500);
      }, 500);
    }
  } else {
    console.log("分岐点2")
    setTimeout(() => {
      lenis.scrollTo(0, {
        duration: 0,  // スクロールにかける時間（ミリ秒）
      });
      setTimeout(() => {
        // ScrollTrigger.clearScrollMemory();
        // ScrollTrigger.refresh();
      }, 500);
    }, 500);
  }
}



function delay(n) {
  n = n || 2000;
  return new Promise((done) => {
    setTimeout(() => {
      done();
    }, n);
  });
}

let currentNamespace = document.querySelector('main[data-barba-namespace]')?.getAttribute('data-barba-namespace') || null;
barba.init({
  transitions: [{
    name: 'default-transition',
    // 現在のページを離れる時のフック
    leave: function (data) {
      // 現在のページを離れる時のアニメーションを設定する
      return new Promise(function (resolve) {
        leaveAnimation(data.current.container);
        setTimeout(function () {
          resolve();
          // ScrollTrigger.getAll().forEach(trigger => trigger.kill(true)); // ← trueを指定してDOMからも消す
        }, 600);
      });
    },
    // 次のページを表示する時のフック
    enter: function (data) {
      // ScrollTrigger.getAll().forEach(trigger => trigger.kill(true)); // ← trueを指定してDOMからも消す
      // ScrollTrigger.refresh();
      window.scrollTo(0, 0);
      // クリックされたリンク情報を取得
      const clickedLink = data.trigger;

      // scrollTopInitにリンク情報を渡す
      scrollTopInit(clickedLink);
      enterAnimation(data.next.container);
      // enterAnimation(data.next.container);
    }
  }]
});

barba.hooks.beforeEnter((data) => {
  // lenis.stop();
  // console.log("Lenisストップした。")
  // 遷移先が "home" の場合にのみ initializeAnimations() を呼び出す
  // setTimeout(() => {
  //   window.scrollTo(0, 0);
  //   const scrollElem = document.scrollingElement || document.documentElement
  //   scrollElem.scrollTop = 0;
  //   console.log("setTimeout後のスクロール位置:", window.scrollY);
  // }, 100);
  currentNamespace = data.next.namespace;
  document.body.classList.remove('index', 'subPage'); // 既存のクラスを一旦削除
  if (data.next.namespace === 'index') {
    document.body.classList.add('index');
    document.body.classList.remove('subPage'); // .subPageを削除
  } else {
    document.body.classList.add('subPage');
    document.body.classList.remove('index'); // .indexを削除
  }
  // if (data.next.namespace === "contact") {
  //   document.querySelector('.cfoot').style.display = 'none';
  // } else {
  //   document.querySelector('.cfoot').style.display = 'block';
  // }
  // lenis.stop();
  // pageLoadedAnimation01()
  function callAllFunctions() {
    replaceHeadTags(data.next);
    commonScriptInit();
    // onWindowLoadScriptInit();
    // isWindowLoaded = true;
    // checkAndRunOnWindowLoadScriptInit();
    onLoadingComplete_mvAnimationInit(); //MVのアニメーション
    // webglTrigger()
    // console.log("遷移後の処理完了")
  }
  setTimeout(callAllFunctions, 100);
});

barba.hooks.afterEnter(() => {
  // scrollTopInit();
  // setTimeout(() => {
  //   window.scrollTo(0, 0);
  // }, 100);
  const videos = document.querySelectorAll(".fxBg video");

  videos.forEach(video => {
    // 再生を試みる
    video.play().catch(() => {
      // Autoplay が失敗した場合（モバイル等）
      video.muted = true;
      video.play().catch(err => {
        console.log("video autoplay failed:", err);
      });
    });
  });
});

function leaveAnimation(target) {
  // boostStarRotation(); // ← ここで回転ブースト発動
  gsap.to(".c_main , footer", {
    opacity: 0,
    duration: 0.6,
    // filter: "blur(20px)"
  });
}

// 通常のbalbaのenterアニメーション
function enterAnimation(e) {
  // console.log("enterAnimation Start")
    gsap.to(".c_main, footer", { 
        opacity: 1,
        duration: 0.5,
        // filter: "blur(0px)",
        delay: 1,
      } // to（最終状態）
    );
}


// 遷移時にheadの情報を変更する
function replaceHeadTags(target) {
  var $newPageHead = $('<head />').html($.parseHTML(target.html.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0], document, true));
  var headTags = [
    "meta[name='keywords']",
    "meta[name='description']",
    "meta[property^='og']",
    "meta[property^='fb']",
    "meta[name^='twitter']",
    "meta[name='robots']",
    "meta[itemprop]",
    "link[itemprop]",
    "link[rel='prev']",
    "link[rel='next']",
    "link[rel='canonical']",
  ].join(',');
  $('head').find(headTags).remove();
  $newPageHead.find(headTags).appendTo('head');
}
// 遷移時にheadの情報を変更する






////////////////////////////////////////////////////////////////////
// 全ページ共通部分 balba.jsの対象外でOK
////////////////////////////////////////////////////////////////////


////////////////////////////////////////////////////////////////////
// ページ毎に呼びだす
////////////////////////////////////////////////////////////////////



let isWindowLoaded = false;
let isCommonScriptInitComplete = false;

function commonScriptInit() {
  if (document.querySelector('.swiper')) initSwiper();
  if (document.querySelector('.swiper02')) initSwiper02();
  if (document.querySelector('.swiper03')) initSwiper03();
  // initCategoryTabs();
  // initModal();
  // initAccordion();
  preventEnterSubmit();

  document.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function (event) {
      // event.preventDefault(); // 通常のリンク動作を防ぐ
      if (!document.body.classList.contains('is_disable')) {
        document.body.classList.add('is_disable'); // bodyにクラス追加

        // 4秒後にクラスを削除
        setTimeout(function () {
          document.body.classList.remove('is_disable');
        }, 2000); // 4秒
      }
    });
  });
  CustomEase.create("customBezier", "M0,0 C0.2,0.9,0.35,0.93 1,1");
  function adjustAspectRatio() {
    // js_aspectRatio クラスを持つすべての要素を取得
    const aspectRationElem = document.querySelectorAll('.js_aspectRatio');

    aspectRationElem.forEach((animationElem) => {
      // ウィンドウのビューポートサイズを取得
      const width = window.innerWidth;
      const height = window.innerHeight;

      // 16:9 の比率で高さを計算
      const aspectHeight = width * 8.5 / 16;

      if (height > aspectHeight) {
        animationElem.style.width = 'auto';
        animationElem.style.height = '110%';
      } else {
        animationElem.style.width = '100%';
        animationElem.style.height = 'auto';
      }
    });
  }
  // ウィンドウのリサイズイベントに応じて関数を呼び出す
  adjustAspectRatio();
  window.addEventListener('resize', adjustAspectRatio);






  class SpanWrap {
    constructor(target) {
      this.target = this.convertElement(target);
      this.nodes = [...this.target.childNodes];
      this.convert();
    }

    convert() {
      let spanWrapText = "";
      this.nodes.forEach((node) => {
        if (node.nodeType == 3) { // テキストノードの場合
          const text = node.textContent.replace(/\r?\n/g, '');
          // テキストを <span><span> で囲んで連結
          spanWrapText = spanWrapText + this.wrapTextWithSpan(text);
        } else if (node.nodeType === 1 && node.classList.contains("js_tAnimation_elem")) {
          // js_tAnimation_elem 要素を <span><span> で囲むが中身はそのまま
          spanWrapText = spanWrapText + `<span><span>${node.outerHTML}</span></span>`;
        } else { // テキスト以外の要素 (例えば <br> など)
          spanWrapText = spanWrapText + node.outerHTML;
        }
      });
      this.target.innerHTML = spanWrapText;
    }

    wrapTextWithSpan(text) {
      return text.split('').reduce((acc, v) => {
        if (v === ' ') {
          // 半角スペースも <span> で囲む
          return acc + `<span class="space">&nbsp;</span>`;
        }
        return acc + `<span><span>${v}</span></span>`;
      }, "");
    }

    // jQueryオブジェクトや文字列セレクターを変換
    convertElement(element) {
      if (element instanceof HTMLElement) {
        return element;
      }
      if (element instanceof jQuery) {
        return element[0];
      }
      return document.querySelector(element);
    }
  }
  // スクリプトの適用
  const targets = [...document.querySelectorAll(".js_tAnimation_01,.js_mv_tAnimation_01,.js_slotTxt > span")]
  targets.forEach((target) => {
    new SpanWrap(target);
  });



  setTimeout(() => {
    const event = new CustomEvent('commonScriptInitComplete');
    document.dispatchEvent(event);
    // console.log('commonScriptInitComplete イベント発火');
  }, 100);

}

// windowLoad後に開始するべき関数 ※非同期遷移後には最後に起動
function onWindowLoadScriptInit() {
  ScrollTrigger.config({
    ignoreMobileResize: true // モバイルのリサイズイベントを無視
  });

function worksTabChangeInit() {
  console.log("onWindowLoadScriptInit 起動")
  const tabButtons = document.querySelectorAll(".works_sldNav_item");
  const tabContents = document.querySelectorAll(".works_tabContent");

  if (tabContents.length) {
    // 初期状態：1つ目だけ表示
    tabContents.forEach((el, i) => {
      gsap.set(el, { opacity: i === 0 ? 1 : 0, display: i === 0 ? "block" : "none" });
    });
    if (tabButtons.length) tabButtons[0].classList.add("is_active");

    tabButtons.forEach(btn => {
      btn.addEventListener("click", () => {
        const targetTag = btn.dataset.tag;

        // ボタンアクティブ切り替え
        tabButtons.forEach(b => b.classList.remove("is_active"));
        btn.classList.add("is_active");
        const letteringEl = btn.querySelector('.works_sldNav_lettering');
        if (letteringEl) {
          // Vivus起動
          new Vivus(letteringEl, {
            type: 'delayed',
            duration: vivusAnimationDuration(250),
            start: 'autostart',
            animTimingFunction: Vivus.EASE_OUT,
          });
        }

        tabContents.forEach(content => {
          const isTarget = content.dataset.tag === targetTag;

          if (isTarget) {
            gsap.set(content, { display: "block" });
            gsap.to(content, { opacity: 1, duration: 1, ease: "power2.out" });
          } else {
            gsap.to(content, {
              opacity: 0,
              duration: 0.3,
              ease: "power2.out",
              onComplete: () => {
                gsap.set(content, { display: "none" });
              }
            });
          }
        });
      });
    });

    // URLパラメータをチェックして自動クリック
    const params = new URLSearchParams(window.location.search);
    // console.log(params)
    // /works?filter=videography の場合 → "videography" を取得
    const targetTag = params.get("filter");
    if (targetTag) {
      const targetBtn = document.querySelector(`.works_sldNav_item[data-tag="${targetTag}"]`);
      if (targetBtn) {
        targetBtn.click(); // 自動的にクリック実行
      }
    }
  }
}
worksTabChangeInit();


  ///////////////////////////////////////////////////////////////////
  // 横スクロールの基礎
  ////////////////////////////////////////////////////////////////////
  function horizontalScrollInit() {
    const sections = document.querySelectorAll('.hs_section');
    if (!sections.length) return;
    console.log("hs_sectionがある場合")
    let scrollAnim = null; // グローバルに宣言しておく
    const isSP = window.innerWidth <= 767;

    if (window.matchMedia("(min-width: 768px)").matches) {
      scrollAnim = gsap.to('.hs_scroller', {
        x: () => -(document.querySelector('.hs_scroller').scrollWidth - window.innerWidth),
        ease: 'none',
        scrollTrigger: {
          trigger: '.hs_container',
          start: 'top top',
          end: () => `+=${document.querySelector('.hs_scroller').scrollWidth - window.innerWidth}`,
          scrub: true,
          pin: true,
          anticipatePin: 1,
          invalidateOnRefresh: true
        }
      });
    }
    //////////////////////////
    //ステップインジケータ
    //////////////////////////
    document.querySelectorAll('.hs_section').forEach((section, i) => {
      const span = document.querySelectorAll('.progressBar_el > span')[i];
      if (!span) return;

      gsap.to(span, {
        clipPath: 'inset(0 0% 0 0)',
        ease: 'none',
        scrollTrigger: {
          trigger: section,
          containerAnimation: scrollAnim, // 横スクロールエレメントをcontainerにすることでleft left に対応可能になる
          start: 'left left',
          end: 'right left',
          start: isSP ? "top top" : "left left",
          end: isSP ? "bottom top" : "right left",
          scrub: 0.3
        }
      });
    });
    //////////////////////////
    //テキストのパララックス
    //////////////////////////
    const txtPllaxElements = gsap.utils.toArray("[data-parallax]");
    txtPllaxElements.forEach((element) => {
      // ブレークポイント：768px以下をSPとする（自由に調整可能）

      // data属性から取得（SP優先）
      const movement = isSP
        ? element.dataset.parallaxSp ?? element.dataset.parallax
        : element.dataset.parallax;

      const elementWidth = element.offsetWidth;

      gsap.to(element, {
        x: movement,
        ease: "none",
        scrollTrigger: {
          trigger: element,
          containerAnimation: scrollAnim,
          // start: "left right",
          // end: `${3 * elementWidth}px left`,
          start: isSP ? "top bottom" : "left right",
          end: isSP ? "bottom top" : `${3 * elementWidth}px left`,
          scrub: 0.5
        }
      });
    });

    //////////////////////////
    //画像の窓枠パララックス
    //////////////////////////
    const imgParallaxElem = gsap.utils.toArray('.js_pllxI img, .js_pllxI video');
    if (window.matchMedia("(max-width: 767px)").matches) {
      var pllxDuration = "5%";
    } else {
      var pllxDuration = "20%";
    }
    imgParallaxElem.forEach((element) => {
      const elementWidth = element.offsetWidth;
      gsap.set(element, {
        scale: "1.2",
      });
      gsap.to(element, {
        [isSP ? "y" : "x"]: pllxDuration, // ← ココがポイント！
        scale: "1.2",
        scrollTrigger: {
          trigger: element,
          start: "top bottom",
          end: "bottom top",
          scrub: .2,
          containerAnimation: scrollAnim,
          start: isSP ? "top bottom" : "left right",
          end: isSP ? "bottom top" : `${3 * elementWidth}px left`,
        },
      });
    });
    //////////////////////////
    //vision終了時の画像残し遅延
    //////////////////////////
    if (window.matchMedia("(max-width: 767px)").matches) {
    }
    else {
      gsap.to(".js_delayFixed", {
        x: `${window.innerWidth}`, // ← ココがポイント！
        ease: "none",
        scale: "1",
        scrollTrigger: {
          trigger: ".js_delayFixed",
          start: "right right",
          // end: "right left",
          end: `+=${window.innerWidth}`,
          scrub: true,
          containerAnimation: scrollAnim,
        },
      });
    }
    //////////////////////////
    //about ~ vision に跨る背景のpllx
    //////////////////////////
    if (window.matchMedia("(max-width: 767px)").matches) {
      var fxBgpllxDuration = "10%";
    } else {
      var fxBgpllxDuration = "5%";
    }
    document.querySelectorAll('.js_fxBg').forEach(fxBgEl => {
      const dataTrigger = fxBgEl.dataset.trigger;
      if (!dataTrigger) return;

      const selector = dataTrigger.startsWith(".") || dataTrigger.startsWith("#")
        ? dataTrigger
        : `.${dataTrigger}`;
      const triggerEl = document.querySelector(selector);
      if (!triggerEl) return;

      const hasAnimation = fxBgEl.dataset.animationFlg === "true";
      const durationValue = hasAnimation ? fxBgpllxDuration : "0%";

      const animProps = {
        ease: "none",
        scrollTrigger: {
          trigger: triggerEl,
          start: isSP ? "bottom bottom" : "right right",
          end: isSP ? `+=${window.innerHeight * 2}` : `+=${window.innerWidth * 2}`,
          scrub: true,
          containerAnimation: scrollAnim,
          onEnter: () => {
            fxBgEl.style.zIndex = "2";
            fxBgEl.style.visibility = "visible";
          },
          onLeave: () => {
            fxBgEl.style.zIndex = "";
            fxBgEl.style.visibility = "hidden";
          },
          onEnterBack: () => {
            fxBgEl.style.zIndex = "2";
            fxBgEl.style.visibility = "visible";
          },
          onLeaveBack: () => {
            fxBgEl.style.zIndex = "";
            fxBgEl.style.visibility = "hidden";
          },
        },
      };

      gsap.registerPlugin(ScrollTrigger);

      document.querySelectorAll('.js_bgDark').forEach(triggerEl => {
        if(triggerEl) {
          ScrollTrigger.create({
            containerAnimation: scrollAnim,
            trigger: triggerEl,
            // start: 'left left',
            // end: 'right left+=5%',
            start: isSP ? "top top" : "left left",
            end: isSP ? "bottom top" : "right left+=5%",
            onEnter: () => {
              if (currentNamespace === 'index') {
                document.querySelector('.c_header').classList.add('is_dark');
                document.querySelector('.c_sideBar').classList.add('is_dark');
                document.querySelector('.progressBar').classList.add('is_dark');
                document.querySelectorAll('.js_bgDark').forEach(el => {
                  el.classList.add('is_active');
                });
                // デバックよう
                // console.log(currentNamespace);
              } else {
                // console.log(currentNamespace);
              }
            },
            onLeave: () => {
              if (currentNamespace === 'index') {
                document.querySelector('.c_header').classList.remove('is_dark');
                document.querySelector('.c_sideBar').classList.remove('is_dark');
                document.querySelector('.progressBar').classList.remove('is_dark');
                document.querySelectorAll('.js_bgDark').forEach(el => {
                  el.classList.remove('is_active');
                });
              }
            },
            onEnterBack: () => {
              if (currentNamespace === 'index') {
                document.querySelector('.c_header').classList.add('is_dark');
                document.querySelector('.c_sideBar').classList.add('is_dark');
                document.querySelector('.progressBar').classList.add('is_dark');
                document.querySelectorAll('.js_bgDark').forEach(el => {
                  el.classList.add('is_active');
                });
              }

            },
            onLeaveBack: () => {
              if (currentNamespace === 'index') {
                document.querySelector('.c_header').classList.remove('is_dark');
                document.querySelector('.c_sideBar').classList.remove('is_dark');
                document.querySelector('.progressBar').classList.remove('is_dark');
                document.querySelectorAll('.js_bgDark').forEach(el => {
                  el.classList.remove('is_active');
                });
              }

            },
          });
        }
      });

      // isSP に応じて y か x に duration を適用（data-animation-flg が true のときだけ）
      if (isSP) {
        animProps.y = durationValue;
      } else {
        animProps.x = durationValue;
      }

      gsap.to(fxBgEl, animProps);
    });
    // gsap.to(".contact", {
    //   scrollTrigger: {
    //     trigger: ".works",
    //     start: isSP ? "bottom bottom" : "right right",
    //     end: isSP ? `+=${window.innerHeight * 2}` : `+=${window.innerWidth * 2}`,
    //     scrub: true,
    //     containerAnimation: scrollAnim,
    //     onEnter: () => this.style.zIndex = "5",
    //     onLeave: () => this.style.zIndex = "",
    //     onEnterBack: () => this.style.zIndex = "5",
    //     onLeaveBack: () => this.style.zIndex = "",
    //   },
    // });


    const txtAnimationItems01 = gsap.utils.toArray('.js_tAnimation_01');
    txtAnimationItems01.forEach((item) => {
      const innerSpans = item.querySelectorAll('span');
      gsap.to(innerSpans, {
        y: 0,
        rotation: 0,
        duration:1.2,
        ease: "circ.out",
        delay: 0.5,
        // ease: "circ.inOut",
        scrollTrigger: {
          trigger: item.closest?.('.js_tAnimationTrigger') || item,
          // start: "right right", // ここは既存の定義に従ってください
          start: isSP ? "bottom bottom" : "left right+=15%",
          // end: isSP ? `+=${window.innerHeight * 2}` : `+=${window.innerWidth * 2}`,
          toggleActions: 'play none none reverse',
          containerAnimation: scrollAnim,
        },
        stagger: {
          from: "start",
          amount: 0.4,
        }
      });
    });





    class TextRepeat {
      constructor(el) {
        this.el = el;
        this.text = el.textContent.trim();
        this.color = el.getAttribute('data-rep-txt-color') || '#fff';
        this.totalCount = 7;
        this.tyIncrement = 20;
        this.delayIncrement = 0.08;
        this.area = el.getAttribute('data-rep-txt') || 'text';
        this.words = [];

        this.build();
        this.setInitial();
        this.animate();
      }

      build() {
        const positions = [
          // { ty: 80, delay: 0.16, item: "lower" },
          // { ty: 40, delay: 0.08, item: "lower" },
          // { ty: 20, delay: 0, item: "lower" },
          // { ty: -60, delay: 0.16, item: "upper" },
          // { ty: -40, delay: 0.08, item: "upper" },
          // { ty: -20, delay: 0, item: "upper" },
          // { ty: 0, delay: 0, item: "undefined" } // 中央
          { ty: 480, delay: 0.16, item: "lower" },
          { ty: 320, delay: 0.08, item: "lower" },
          { ty: 160, delay: 0, item: "lower" },
          { ty: -480, delay: 0.16, item: "upper" },
          { ty: -320, delay: 0.08, item: "upper" },
          { ty: -160, delay: 0, item: "upper" },
          { ty: 0, delay: 0, item: "undefined" } // 中央
        ];

        let html = '';
        positions.forEach(pos => {
          html += `<span data-delay="${pos.delay}" data-ty="${pos.ty}" data-rep-txt-item="${pos.item}">${this.text}</span>`;
        });

        this.el.innerHTML = html;
        this.words = Array.from(this.el.querySelectorAll('span'));
      }

      setInitial() {
        this.words.forEach(span => {
          const ty = span.getAttribute('data-ty');
          const delay = span.getAttribute('data-delay');
          gsap.set(span, {
            yPercent: ty,
            delay: delay,
            // opacity: 1
          });
        });

        const marginOffset = (this.tyIncrement * Math.floor(this.totalCount / 2));
        gsap.set(this.el, {
          // marginTop: marginOffset / 2,
          // paddingBottom: marginOffset
        });
      }

      animate() {
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: this.el,
            start: "left center",
            end: "left left",
            // end: `+=${window.innerHeight * 0.8}`, 
            scrub: 0.4,
            containerAnimation: scrollAnim,
          }
        });

        const selector = `[data-rep-txt="${this.area}"]`;

        tl.to(`${selector} [data-rep-txt-item="upper"]`, {
          ease: "power3.inOut",
          yPercent: 0,
          duration: 0.3,
          stagger: { each: 0.01, from: "end" },
          force3D: false
        }, 0)
          .to(`${selector} [data-rep-txt-item="lower"]`, {
            ease: "power3.inOut",
            yPercent: 0,
            duration: 0.3,
            stagger: { each: 0.01, from: "start" },
            force3D: false
          }, "<")
          .to(this.el, {
            ease: "power3.inOut",
            marginTop: 0,
            paddingBottom: 0,
            duration: 0.3,
            force3D: false
          }, "<")
          .to(`${selector} [data-rep-txt-item]`, {
            duration: 0.03,
            "-webkit-text-fill-color": this.color,
            "-webkit-text-stroke-color": this.color
          }, "<")
          .set(`${selector} [data-rep-txt-item]`, {
            backgroundColor: "transparent"
          }, "<0.01")
          .set([`${selector} [data-rep-txt-item="upper"]`, `${selector} [data-rep-txt-item="lower"]`], {
            opacity: 0
          },)
      }
    }
    // 起動処理（クラス名だけ変更）
    document.querySelectorAll('.js_indexTxt_el').forEach(el => {
      new TextRepeat(el);
    });
    document.querySelectorAll('[data-scroll-target]').forEach(anchor => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();

        const targetId = anchor.getAttribute('data-scroll-target');
        const isSP = window.innerWidth <= 767;
        const container = isSP ? undefined : document.querySelector('.hs_scroller');

        let targetPos;

        if (targetId === "end") {
          // 最後尾へスクロール
          if (isSP) {
            // SPの場合はinnerHeight
            targetPos = document.body.scrollHeight - window.innerHeight;
          } else if (container) {
            // innerWidth
            targetPos = container.scrollWidth - window.innerWidth;
          } else {
            return; // コンテナがなければ処理しない
          }
        } else {
          const target = document.getElementById(targetId);
          if (!target) return;
          targetPos = isSP ? target.offsetTop : target.offsetLeft;
        }

        lenis.scrollTo(targetPos, {
          duration: 1.2,
          lerp: 0.1,
          container: container
        });
      });
    });
  }
  horizontalScrollInit();
  // enterAnimation()
  // setTimeout(() => {
  // }, 200);
  ///////////////////////////////////////////////////////////////////
  // パララックスアニメーション
  ////////////////////////////////////////////////////////////////////
  if (window.matchMedia("(min-width: 768px)").matches) {
    gsap.set('.js_pllx_el', {
      y: 50,
    });
    const standardPalllaxEl = gsap.utils.toArray('.js_pllx_el');
    standardPalllaxEl.forEach((item) => {
      gsap.to(item, {
        y: 0,
        rotation: 0,
        // duration: 0.5,
        scrollTrigger: {
          trigger: item,
          start: "top bottom",
          end: "top top",
          scrub: true,
        },
        // onComplete: () => {
        //   // アニメーションが完了したら overflow を unset
        //   innermostSpans.style.overflow = "unset";
        // }
      });
    });
    gsap.set('.js_pllx_el_R', {
      y: -50,
    });
    const standardPalllaxElReverse = gsap.utils.toArray('.js_pllx_el_R');
    standardPalllaxElReverse.forEach((item) => {
      gsap.to(item, {
        y: 0,
        rotation: 0,
        // duration: 0.5,
        scrollTrigger: {
          trigger: item,
          start: "top bottom",
          end: "top top",
          scrub: true,
        },
        // onComplete: () => {
        //   // アニメーションが完了したら overflow を unset
        //   innermostSpans.style.overflow = "unset";
        // }
      });
    });
  }

  ///////////////////////////////////////////////////////////////////
  // テキストアニメーション ※ピン留めしている要素などの読み込みが完了してから呼び出さないと発火位置がズレる。
  ////////////////////////////////////////////////////////////////////
  //   setTimeout(() => {
  //   document.querySelector('.js_mediaFade').classList.add('is_animated');
  // }, 1);
  document.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', function (e) {
      const currentUrl = location.href.split('#')[0];
      const linkUrl = this.href.split('#')[0];

      if (currentUrl === linkUrl) {
        // 同じURLならキャンセル
        e.preventDefault();
        console.log('同じURLのため遷移キャンセル');
      }
    });
  });


  const hoverSlotTxtAnimation = gsap.utils.toArray('.js_slotTxt');

  hoverSlotTxtAnimation.forEach((item) => {
    const target01 = item.querySelectorAll(':scope > span:nth-of-type(1) > span');
    const target02 = item.querySelectorAll(':scope > span:nth-of-type(2) > span');

    // inline の場合の見え方安定
    gsap.set([target01, target02], { display: 'inline-block' });

    const tl = gsap.timeline({
      paused: true,
      defaults: { duration: 1, ease: 'expo.inOut', overwrite: 'auto' }
    })
    .to(target01, {
      y: '-100%',
      rotation: 0,
      // まとまった時間で均等配分 → amount
      stagger: { from: 'start', amount: 0.2 }
    }, 0)
    .to(target02, {
      y: '-100%',
      rotation: 0,
      // 各要素ごとに固定間隔 → each（どちらでも可。好みで）
      stagger: { from: 'start', each: 0.02 }
    }, 0);

    // 直親でなくても OK（最も近い .js_slot 祖先を拾う）
    const slot = item.closest('.js_slot') || item;

    slot.addEventListener('mouseenter', () => tl.restart());
    slot.addEventListener('mouseleave', () => tl.reverse()); // 逆戻り不要なら削除
  });

  const hoverSlotArrowAnimation = gsap.utils.toArray('.js_slotArrowWrapper');
  hoverSlotArrowAnimation.forEach((item) => {
    const arrows = item.querySelectorAll('.js_slotArrow');
    if (arrows.length < 2) return; // 念のためガード

    const tl = gsap.timeline({
      paused: true,
      defaults: { duration: 1, ease: 'expo.inOut', overwrite: 'auto' }
    });

    // 初期位置をセット（2つ目は右にずらしておく）
    gsap.set(arrows[0], { xPercent: -150 }); 
    gsap.set(arrows[1], { xPercent: 0 });

    // アニメーション定義
    tl.to(arrows[0], { xPercent: 0 }, 0)      // 1つ目 → 0%
      .to(arrows[1], { xPercent: 100 }, 0);   // 2つ目 → 100%

    // 直親でなくても OK（最も近い .js_slot 祖先を拾う）
    const slot = item.closest('.js_slot') || item;

    slot.addEventListener('mouseenter', () => tl.restart());
    slot.addEventListener('mouseleave', () => tl.reverse()); // 逆戻り不要なら削除
  });
  // ScrollTrigger.clearScrollMemory();
  // ScrollTrigger.refresh();
  
}
document.addEventListener('DOMContentLoaded', commonScriptInit);


////////////////////////////////////// commonScriptInit の後に onWindowLoadScriptInitを起動するためのスクリプト
// カスタムイベントをリッスン
document.addEventListener('commonScriptInitComplete', function () {
  isCommonScriptInitComplete = true;
  checkAndRunOnWindowLoadScriptInit();
});

// window の load イベントをリッスン
window.addEventListener('load', function () {
  isWindowLoaded = true;
  checkAndRunOnWindowLoadScriptInit();
});

// 両方が完了したときに onWindowLoadScriptInit を実行
function checkAndRunOnWindowLoadScriptInit() {
  if (isWindowLoaded && isCommonScriptInitComplete) {
    onWindowLoadScriptInit();
  }
}
///////////////////////////////////////











////////////////////////////////////////////////////////////////////
// ローディング完了後に呼びだす
////////////////////////////////////////////////////////////////////

// スプラッシュ
// スプラッシュ終了後のMVアニメーション
function onLoadingComplete_mvAnimationInit() {
  setTimeout(() => {
      const innerSpans = document.querySelectorAll('.js_mv_tAnimation_01 span');
      gsap.to(innerSpans, {
        y: 0,
        rotation: 0,
        duration:1.2,
        ease: "circ.out",
        delay: 0.2,
        // ease: "circ.inOut",
        // scrollTrigger: {
        //   trigger: item.closest?.('.js_tAnimationTrigger') || item,
        //   start: "top top", // ここは既存の定義に従ってください
        //   // start: isSP ? "bottom bottom" : "left right+=15%",
        //   // end: isSP ? `+=${window.innerHeight * 2}` : `+=${window.innerWidth * 2}`,
        //   toggleActions: 'play none none reverse',
        //   // containerAnimation: scrollAnim,
        // },
        stagger: {
          from: "start",
          amount: 0.4,
        },
        onComplete: () => {
          document.querySelectorAll('.js_mv_vivus').forEach((el) => {
            if(el) {
              gsap.to(el, {
                autoAlpha: 1,
                duration: 0,
              });
              new Vivus("js-vivus-target1", {
                // type: 'delayed',    // 描画タイプ
                // duration: 150,      // アニメーション時間
                // animTimingFunction: Vivus.EASE,
                duration: vivusAnimationDuration(400), // アニメーションの長さ
                forceRender: false, //パスが更新で再レンダリングさせない
                animTimingFunction: Vivus.EASE_OUT, // 自動開始
                start: "inViewport"
              }, () => {
                // console.log('✅ Vivusアニメーション完了！');
              });
            }
          });

        }
      });  

  }, 140);
}



// ヘッダーの出現 スプラッシュの有無で変わるためかき分ける
function header_animationInit(config) {
  // デフォルト値を設定
  const defaults = {
    delayTime: 0, // 遅延時間
    duration: 0.4, // アニメーションの長さ
    y: 0, // y座標
    opacity: 1, // 不透明度
  };
  // デフォルト値とユーザー指定値をマージ
  const settings = { ...defaults, ...config };
  // アニメーション実行
  // gsap.killTweensOf(".header"); // アニメーション競合防止
  gsap.to(".cm_header", {
    delay: settings.delayTime,
    duration: settings.duration,
    y: settings.y,
    opacity: settings.opacity,
    ease: "elastic.out(1.1,0.7)",
  });
}




////////////////////////////////////////////////////////////////////
// ローディングの有無での分岐 ＆　スプラッシュ
////////////////////////////////////////////////////////////////////
const splashAnimationInit = () => {
  lenis.stop();
  var target = document.querySelector('.loading');
  var path = window.location.pathname
  if (
    target &&
    path !== '/contact/' &&
    path !== '/confirm/' &&
    path !== '/complete/'
  ) {
    // Vivus の初期化
    const vivus = new Vivus("loading_letter_el", {
      type: 'delayed',
      duration: 200,
      forceRender: false,
      start: 'manual'
    }, () => {
      console.log('✅ Vivusアニメーション完了！');
      splashTxtSlot(); // 完了後の処理
    });

    const isSP = window.matchMedia("(max-width: 767px)").matches;
    if (isSP) {
      vivus.finish();
    }
    gsap.to(".loading_letter", {
      autoAlpha: 1,
      delay: isSP ? 0.5 : 0,   // ✅ SPのときだけ delay 0.2
      duration: isSP ? 0.4 : 0.2, // ✅ SPのときだけ duration 0.4
      onComplete: () => {
        if (isSP) {
          // ✅ SP の場合は Vivus をスキップして即完成にする
          splashTxtSlot();
        } else {
          // ✅ PC の場合は普通に再生
          vivus.play();
        }
      }
    });

    function splashTxtSlot() {
      const tl = gsap.timeline();
      tl.to(".loading_afterEl", {
        y: 0,
        rotation: 0,
        duration: 1.4,
        ease: "expo.inOut",
        delay: isSP ? 0.5 : 0,
        // stagger: {
        //   from: "start",
        //   amount: 0.2,
        // }
      })
      .to(".loading_letter", {
        y: "-125%",
        rotation: -15,
        duration: 1.4,
        ease: "expo.inOut",
      }, "<"); // 前のアニメーションと同時に開始
      // .to(".loading_beforeEl", {
      //   y: "-115%",
      //   rotation: -15,
      //   duration: 1.4,
      //   ease: "expo.inOut",
      //   stagger: {
      //     from: "start",
      //     amount: 0.2,
      //   }
      // }, "<"); // 前のアニメーションと同時に開始
      tl.eventCallback("onComplete", () => {
        gsap.to(".loading", {
          // autoAlpha: 0,
          delay: 0,
          duration: 1.4,
          // clipPath: "inset(100% 0% 0% 0%)", // 上から100%まで切り取る
          clipPath: "inset(0% 0% 100% 0%)", // 下（bottom）を100%切り取る
          // filter: "blur(20px)",
          // ease: "power2.out",
          ease: "expo.inOut",
          onComplete: () => {
            onLoadingComplete_mvAnimationInit();
            header_animationInit({ delayTime: 0.8 });
            lenis.start();

            // gsap.to(".fxBg video", { 
            //   autoAlpha: 1,
            //   // visibility: hidden;
            //   // opacity: 0;
            // });
          }
        });
      });
    }

  } else {
    // gsap.to(".loading", {
    //   autoAlpha: 0,
    // });
    onLoadingComplete_mvAnimationInit();
    header_animationInit({ delayTime: 0.8 });
    lenis.start();
    window.addEventListener('load', function () {

    });
  }
};
// window.onload = splashAnimationInit;
window.addEventListener('load', () => {
  // 動画以外のJSだけ動くようにする
  splashAnimationInit();
});
// mvFrontNoise();

// pageLeaveAnimationPixel();

